"use client";

import { useEffect } from "react";
import { Container } from "@/components/layout/Container";

export default function GlobalError({
  error,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error("[app error]", error);
  }, [error]);

  return (
    <section className="min-h-[65vh] grid place-items-center py-16">
      {/* App-router client error boundaries can't export `metadata`; Next
          hoists a <meta> rendered anywhere in the tree to <head>. Keep any
          error state out of the index. */}
      <meta name="robots" content="noindex,nofollow" />
      <Container className="text-center max-w-xl">
        <div className="mx-auto max-w-screen-sm text-center">
          <h1 className="mb-4 text-7xl tracking-tight font-extrabold lg:text-9xl text-primary-600 dark:text-primary-500">
            500
          </h1>
          <p className="mb-4 text-3xl tracking-tight font-bold text-headings md:text-4xl dark:text-white">
            Internal Server Error.
          </p>
          <p className="mb-4 text-lg font-light text-gray-500 dark:text-gray-400">
            We are already working to solve the problem.{" "}
          </p>
        </div>
      </Container>
    </section>
  );
}
